// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1k0fu","col":"styles_col__2R7HI"};